import { useEffect, useState } from 'react';

function secondsUntil(date: Date | null): number {
  if (!date) return 0;
  return Math.max(0, Math.ceil((date.getTime() - Date.now()) / 1000));
}

/** Counts down to `date`, once a second; 0 once it has passed. */
export function useSecondsUntil(date: Date | null): number {
  const [seconds, setSeconds] = useState(() => secondsUntil(date));

  useEffect(() => {
    setSeconds(secondsUntil(date));
    if (!date) return;
    const interval = window.setInterval(() => {
      const remaining = secondsUntil(date);
      setSeconds(remaining);
      if (remaining === 0) window.clearInterval(interval);
    }, 1000);
    return () => window.clearInterval(interval);
  }, [date]);

  return seconds;
}
